export const specific = {
    name: 'mobapmst.com',
    email: 'support@mobileappmasters.com',
    phone: '+359 32 540 395',
};

export const baseUrl = 'https://mobileappmasters.com/';
